/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordCounts } from "../../records/types/RecordCounts";
export const RecordCountsResponseData = core.serialization.object({
    counts: RecordCounts,
    success: core.serialization.boolean(),
});
